import { Platform, View } from "react-native";
import { useActiveAgent } from "../contexts/ActiveAgentContext";
import { useEffect, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import LoadingView from "../components/common/loading-view";
import { ErrorDisplay } from "../components/common/error-display";
import WebView from "react-native-webview";
import { useViewport } from "../hooks/useViewport";

export default function Metrics() {
  const { getToken } = useAuth();
  const { width, height } = useViewport();
  const { activeAgent } = useActiveAgent();
  const [metricsWidget, setMetricsWidget] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetricsWidget = async () => {
      setLoading(true);
      setError(null);
      try {
        const endpoint = `${process.env.EXPO_PUBLIC_API_BASE}/agents/${activeAgent?.id}/metrics`;
        const response = await fetch(endpoint, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }
        const data = await response.json();
        const metricsWidget = await data.iframeUrl;
        setMetricsWidget(metricsWidget);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (activeAgent?.id) {
      fetchMetricsWidget();
    }
  }, [activeAgent?.id]);

  if (!activeAgent) {
    return null;
  }

  if (loading) {
    return <LoadingView />;
  }

  if (error) {
    return (
      <ErrorDisplay message="We're having trouble loading your metrics." />
    );
  }

  return (
    <View className="flex-1 items-center justify-center bg-white sm:pl-20">
      {metricsWidget ? (
        Platform.OS === "web" ? (
          <iframe
            src={metricsWidget}
            title="Metrics Dashboard"
            width={width}
            height={height}
          />
        ) : (
          <WebView source={{ uri: metricsWidget }} style={{ width, height }} />
        )
      ) : null}
    </View>
  );
}
